import { StoredSearchQuery } from "../types/stored-search-queries";

export function setStoredSearchQuery(newQuery: StoredSearchQuery): void {
    let queries: StoredSearchQuery[] = getStoredSearchQueries();
    queries = queries.filter((q) => q.name.toLowerCase() !== newQuery.name.toLowerCase());
    queries.push(newQuery);
    if (queries.length > 6) queries.shift();
    localStorage.setItem("searchQueries", JSON.stringify(queries));
}

export function getStoredSearchQueries(): StoredSearchQuery[] {
    return JSON.parse(localStorage.getItem("searchQueries") ?? "[]");
}
